import ReviewMoreLayout from "@/domain/reviewMore/ReviewMoreLayout";
import APILayout from "../components/Layout/APILayout";
const ReviewMore = () => {
    return (
        <APILayout modal={null}>
            <ReviewMoreLayout />
        </APILayout>
    );
};

export default ReviewMore;
